import { privateAxios } from '@/services/api'

export const _getAccount = () => {
    return privateAxios.get('/account')
        .then(response => response.data)
}

export const _createAccount = (data) => {
    return privateAxios.post('/account', data)
        .then(response => response.data)
}

export const _deleteAccount = (data) => {
    return privateAxios.delete('/account', data)
        .then(response => response.data)
}

export const _updateAccount = (data) => {
    return privateAxios.put('/account', data)
        .then(response => response.data)
}

export const _updateAccountSettings = (data) => {
    return privateAxios.put('/account/settings', data)
        .then(response => response.data)
}

export const _confirmEmail = (data) => {
    return privateAxios.post('/account/confirm-email', data)
        .then(response => response.data)
}

export const _forgottenPassword = (data) => {
    return privateAxios.post('/account/forgotten-password', data)
        .then(response => response.data)
}

export const _resetPassword = (data) => {
    return privateAxios.post('/account/reset-password', data)
        .then(response => response.data)
}

export const _verifyToken = (data) => {
    return privateAxios.post('/account/verify', data)
        .then(response => response.data)
}

export const _confirmAccount = (data) => {
    return privateAxios.post('/account/confirm', data)
        .then(response => response.data)
}

export const _loginSessions = () => {
    return privateAxios.get('/account/login-sessions')
        .then(response => response.data)
}

export const _changePassword = (data) => {
    return privateAxios.put('/account/change-password', data)
        .then(response => response.data)
}

export const _resendVerification = () => {
    return privateAxios.put('/account/resend-verification')
        .then(response => response.data)
}

export const _closeInfo = (data) => {
    return privateAxios.put('/account/closed-info', data)
        .then(response => response.data)
}
